import { actionsRequest, handleRequestError } from '@/api/utils'
import { Action, ACTION_TYPE } from '@/types/action'
import { ERROR_CODE } from '@/types/error'

export const getConfig = async <T extends Action<ACTION_TYPE.GET_CONFIG>>(): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload: {},
      type: ACTION_TYPE.GET_CONFIG
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    const { config } = body.data

    return {
      config
    }
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.GET_CONFIG, {})
    throw err
  }
}
